// @flow
/* eslint-disable react/no-danger */
import React from 'react';

const icon = {
    __html: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14">
    <g fill-rule= "nonzero" stroke="none">
        <path d="M5.9 5.3c-.414-.4-1.035-.4-1.449 0-.414.4-.414 1 0 1.4l2.07 2c.208.2.415.3.725.3s.518-.1.725-.3l7.246-7c.414-.4.414-1 0-1.4-.414-.4-1.035-.4-1.45 0l-6.52 6.3L5.9 5.3z"/>
        <path d="M7.246 14c4.037 0 7.246-3.1 7.246-7 0-.6-.414-1-1.035-1-.62 0-1.035.4-1.035 1 0 2.8-2.277 5-5.176 5C4.348 12 2.07 9.8 2.07 7s2.278-5 5.176-5c.621 0 1.139.1 1.76.3.518.2 1.139-.1 1.346-.6.207-.5-.104-1.1-.621-1.3C8.903.1 8.074 0 7.246 0 3.21 0 0 3.1 0 7s3.209 7 7.246 7z"/>
    </g>
    </svg>`
};

export const IconCheckCircle = () => <span dangerouslySetInnerHTML={icon} />;

export default IconCheckCircle;
